"use strict";

require("core-js/modules/es6.date.to-json");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __values = this && this.__values || function (o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); //================================================================ 

/** @module std */
//================================================================

var HashMap_1 = require("../container/HashMap");

var global_1 = require("./global");
/**
 * Condition variable.
 *
 * @author Jeongho Nam <http://samchon.org>
 */


var ConditionVariable =
/** @class */
function () {
  /* ---------------------------------------------------------
      CONSTRUCTORS
  --------------------------------------------------------- */

  /**
   * Default Constructor.
   */
  function ConditionVariable() {
    this.resolvers_ = new HashMap_1.HashMap();
  }
  /* ---------------------------------------------------------
      NOTIFIERS
  --------------------------------------------------------- */

  /**
   * Notify, wake one.
   */


  ConditionVariable.prototype.notify_one = function () {
    return __awaiter(this, void 0, void 0, function () {
      var it;
      return __generator(this, function (_a) {
        // NOTHING TO NOTIFY
        if (this.resolvers_.empty()) return [2
        /*return*/
        ];
        it = this.resolvers_.begin();
        this.resolvers_.erase(it); // CALL ITS HANDLER

        if (it.second === 0
        /* HOLD */
        ) it.first();else it.first(true);
        return [2
        /*return*/
        ];
      });
    });
  };
  /**
   * Notify, wake all
   */


  ConditionVariable.prototype.notify_all = function () {
    return __awaiter(this, void 0, void 0, function () {
      var resolvers, resolvers_1, resolvers_1_1, pair;

      var e_1, _a;

      return __generator(this, function (_b) {
        // NOTHING TO NOTIFY
        if (this.resolvers_.empty()) return [2
        /*return*/
        ];
        resolvers = this.resolvers_.toJSON();
        this.resolvers_.clear();

        try {
          // ITERATE RESOLVERS
          for (resolvers_1 = __values(resolvers), resolvers_1_1 = resolvers_1.next(); !resolvers_1_1.done; resolvers_1_1 = resolvers_1.next()) {
            pair = resolvers_1_1.value;
            if (pair.second === 0
            /* HOLD */
            ) pair.first();else pair.first(true);
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (resolvers_1_1 && !resolvers_1_1.done && (_a = resolvers_1.return)) _a.call(resolvers_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  ConditionVariable.prototype.wait = function (predicator) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!predicator) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , this._Wait()];

          case 1:
            return [2
            /*return*/
            , _a.sent()];

          case 2:
            return [4
            /*yield*/
            , predicator()];

          case 3:
            if (!!_a.sent()) return [3
            /*break*/
            , 5];
            return [4
            /*yield*/
            , this._Wait()];

          case 4:
            _a.sent();

            return [3
            /*break*/
            , 2];

          case 5:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ConditionVariable.prototype.wait_for = function (ms, predicator) {
    var at = new Date(Date.now() + ms);
    return this.wait_until(at, predicator);
  };

  ConditionVariable.prototype.wait_until = function (at, predicator) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!!predicator) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , this._Wait_until(at)];

          case 1:
            return [2
            /*return*/
            , _a.sent()];

          case 2:
            return [4
            /*yield*/
            , predicator()];

          case 3:
            if (!!_a.sent()) return [3
            /*break*/
            , 7];
            return [4
            /*yield*/
            , this._Wait_until(at)];

          case 4:
            if (!!_a.sent()) return [3
            /*break*/
            , 6];
            return [4
            /*yield*/
            , predicator()];

          case 5:
            return [2
            /*return*/
            , _a.sent()];

          case 6:
            return [3
            /*break*/
            , 2];

          case 7:
            return [2
            /*return*/
            , true];
        }
      });
    });
  };
  /**
   * @hidden
   */


  ConditionVariable.prototype._Wait = function () {
    var _this = this;

    return new Promise(function (resolve) {
      _this.resolvers_.emplace(resolve, 0
      /* HOLD */
      );
    });
  };
  /**
   * @hidden
   */


  ConditionVariable.prototype._Wait_until = function (at) {
    var _this = this;

    return new Promise(function (resolve) {
      _this.resolvers_.emplace(resolve, 1
      /* KNOCK */
      ); // AUTOMATIC UNLOCK


      global_1.sleep_until(at).then(function () {
        if (_this.resolvers_.has(resolve) === false) return; // DO UNLOCK

        _this.resolvers_.erase(resolve); // POP THE LISTENER


        resolve(false); // RETURN FAILURE
      });
    });
  };

  return ConditionVariable;
}();

exports.ConditionVariable = ConditionVariable;
exports.condition_variable = ConditionVariable;